function isHttpErrorStatus(value: unknown): value is number {
  return (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= 400 &&
    value < 600
  );
}

/** Читаем статус без преобразования типов и рекурсии; циклический cause завершает поиск. */
export function readHttpErrorStatus(error: unknown): number | undefined {
  const visited = new WeakSet<object>();
  let current = error;
  while (
    current !== null &&
    typeof current === 'object' &&
    !visited.has(current)
  ) {
    visited.add(current);
    const node = current as {
      status?: unknown;
      statusCode?: unknown;
      cause?: unknown;
    };
    if (isHttpErrorStatus(node.status)) return node.status;
    if (isHttpErrorStatus(node.statusCode)) return node.statusCode;
    current = node.cause;
  }
  return undefined;
}
